module.exports = __webpack_public_path__ + "img/logo3.f3f79a63.png";